import { render, staticRenderFns } from "./UppercasedStringRenderer.vue?vue&type=template&id=2569b3cc&"
import script from "./UppercasedStringRenderer.vue?vue&type=script&lang=js&"
export * from "./UppercasedStringRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports